import React, { useState, useEffect } from "react";
import { app, db } from "../../firebase";
import { addDoc, collection,onSnapshot ,query} from "firebase/firestore";
import { getAuth} from "firebase/auth";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import swal from "sweetalert";


function AdminPanel() {
  const [postheader, setPostHeader] = useState("");
  const [postImage, setPostImage] = useState(null);
  const [description, setDescription] = useState("");
  const [btnUrlOne, setBtnUrlOne] = useState("");
  const [btnUrlTwo, setBtnUrlTwo] = useState("");
  const [image, setImage] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [warn, setWarn] = useState(false);
  const [wait, setWait] = useState(false);
  const [preview, setPreview] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false)
  const [serialNumber, setSerialNumber] = useState()

  const auth = getAuth(app);
  const uploadImage = async (e) => {
    e.preventDefault(e);
    if (image === null) {
      return setWarn(
        <div className="text-sm">
          Pehle koi photo toh select kr lo re Babua 😂
        </div>
      );
    }
    const storage = getStorage();
    // Create the file metadata
    /** @type {any} */
    const metadata = {
      contentType: "image/jpeg",
    };

    // Upload file and metadata to the object 'images/mountains.jpg'
    const storageRef = ref(storage, `'images/'${image.name}/${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, image, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setWarn(false);
        setProcessing("Upload is " + progress + "% done");
        setWait(
          <div className=" text-teal-800 text-sm">
             wait bro ! Uploading image to firebase..
          </div>
        );

        if (progress === 100) {
          setWait(false);
          setProcessing(false);
          setWarn(false);
          setUploaded(
            <div className="text-green-800 font-semibold">
              🤪 Image upload ho gya h, ab post ko upload krr do.. ✅
            </div>
          );
        }
        switch (snapshot.state) {
          case "paused":
            console.log("paused");
            break;
          case "running":
            console.log("upload is runnig");
            break;
        }
      },
      (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break;
          case "storage/canceled":
            // User canceled the upload
            break;

          // ...

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // console.log("File available at", downloadURL);
          setPostImage(downloadURL);
        });
      }
    );
  };

  const handleSubmit = async(e) => {
    e.preventDefault(e)
    await addDoc(collection(db, "AllPosts"), {
      postheader,
      description,
      btnUrlOne,
      btnUrlTwo,
      postImage,
      serialNumber,
    });
      // alert("Post Uploaded, Please Check Your Firebase ! and Smile ")
      setRefreshPage(true)
      swal("Success","Post Uploaded, Please Check Your Firebase ! and Smile","success")
      .then(()=>{
        swal("Refresh Now !","Please refresh this page now !","info")
      })
  };

// total posts
  const [ dataRecords, setDataRecords] = useState([])
  useEffect(() => {
  const q  = query(collection(db,"AllPosts"));    
  const unsub = onSnapshot(q, (querySnapshot) => {
      let todoArray = [];
      querySnapshot.forEach((doc) => {
        todoArray.push({...doc.data(),
           id: doc.id 
          });
      })
      setDataRecords(todoArray)
    })
    return () => unsub()
},[])

  const handleRefresh = () => {
    window.location.reload()
    swal("success","page refreshed successfully","success")
  }

  const signout = async () => {
    await auth.signOut();
  };

  return (
    <>
      <div className="bg-black justify-center items-center h-auto container pb-20">
        <div className="row justify-center items-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="">
              <div className="justify-center items-center max-w-full text-center mx-auto my-auto pt-20 ">
                <div className="text-white text-3xl">Admin Panel</div>
                <div className="">
                  <form className="form-control flex justify-center items-center flex-col gap-3 p-3">
                    {/* post serial number */}
                    <div className="flex flex-col text-left w-full">
                      <label>This Post's Serial Number is {dataRecords.length+1}  </label>
                      <input
                        className="w-full form-control"
                        type="number"
                        onChange={(e) => setSerialNumber(e.target.value)}
                        placeholder={dataRecords.length+1}
                      />
                    </div>
                    {/* post hedaer */}
                    <div className="flex flex-col text-left w-full">
                      <label>Post Header</label>
                      <input
                        className="w-full form-control"
                        type="title"
                        onChange={(e) => setPostHeader(e.target.value)}
                        placeholder="post header"
                      />
                    </div>

                    {/* post description */}
                    <div className="flex flex-col text-left w-full">
                      <label>Post Description</label>
                      <textarea cols={5} rows={5}
                        className="w-full form-control"
                        type="text"
                        maxLength={200}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="post description"
                      />
                    </div>

                    {/* post btn 1 url */}
                    <div className="flex flex-col text-left w-full">
                      <label>Post Button url</label>
                      <input
                        className="w-full form-control"
                        type="text"
                        onChange={(e) => setBtnUrlOne(e.target.value)}
                        placeholder="download url "
                      />
                    </div>

                    {/* post btn 2 url */}
                    <div className="flex flex-col text-left w-full">
                      <label>youtube video url</label>
                      <input
                        className="w-full form-control"
                        type="text"
                        onChange={(e) => setBtnUrlTwo(e.target.value)}
                        placeholder="youtube video url"
                      />
                    </div>

                    {/* post image*/}
                    <div className="flex flex-row text-left w-full gap-2 form-control">
                      {/* <label className='btn waves-effect #fbc02d bg-yellow-600 text-sm text-white w-44 drop-shadow-sm hover:bg-yellow-700'>Upload image</label> */}
                      <input
                        className="w-full  p-2"
                        type="file"
                        accept="image/*"
                        onChange={(e) => setImage(e.target.files[0])}
                      />
                      <button
                        className="btn btn-warning px-1 text-xs"
                        onClick={uploadImage}
                      >
                        upload image
                      </button>
                    </div>
                    <div>
                      {processing}
                      {uploaded}
                      {warn}
                      {wait}
                    </div>
                    {
                      postImage === null ? (
                        <div className="btn btn-primary text-white disabled" >Preview Image</div>
                      ) : (
                        <div className="btn btn-primary text-white" onClick={()=>postImage ? setPreview(!preview):setPreview(false)}>Preview Image</div>
                      )
                    }
                    {preview ? (
                      <div className="border rounded overflow-hidden m-3">
                        <img 
                          className="cover center bg-center"
                          src={postImage}
                          style={{ height: 160, width: 350 }}
                        />
                      </div>
                    ) : null}

                    {postImage === null ? (
                      <button
                        className="btn btn-disabled text-black"
                        disabled
                      >
                        Upload Post
                      </button>
                    ) : (
                      refreshPage === false ? 
                      <button
                        type="submit"
                        className="btn btn-success text-black"
                        onClick={handleSubmit}>Upload Post</button> : <button className="btn btn-warning text text-black" onClick={handleRefresh}>Refresh Page</button>
                    )}
                  </form>
                  <div className="form-control mt-2">
                    <button className="btn btn-secondary disabled">Manage Posts</button>
                  </div>
                  <div className="form-control p-4 mt-20">
                  <button
                    onClick={() => signout()}
                    className="btn btn-success text-white font-semibold"
                  >
                    Log Out
                  </button>                  </div>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminPanel;
